import { render, staticRenderFns } from "./CaseSharing.vue?vue&type=template&id=b0525ffc&scoped=true&"
import script from "./CaseSharing.vue?vue&type=script&lang=js&"
export * from "./CaseSharing.vue?vue&type=script&lang=js&"
import style0 from "./CaseSharing.vue?vue&type=style&index=0&id=b0525ffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0525ffc",
  null
  
)

export default component.exports